'use strict';

const _ = require('lodash');

const stickyClass = 'has-sticky-header';
const $html = $('html');
const $body = $('body');
const $topBanner = $('#header');
const $plpFilters = $('.mobile-refinement-filter');
let topBannerHeight = $topBanner.outerHeight();
let headerOffsetTop = $topBanner.offset().top || 0;
let plpFilterHeight = $plpFilters.length ? $plpFilters.outerHeight() + 10 : 0;
if ($plpFilters.length) {
    $plpFilters.css('top', topBannerHeight + 'px');
}
let hasStickyFilter;
let stickyHeight;

const doSticky = () => {
    const scrollTop = Math.max($html.scrollTop(), $body.scrollTop());
    const isSticky = scrollTop >= headerOffsetTop;
    $html.toggleClass(stickyClass, isSticky);
    hasStickyFilter = $plpFilters.length && ['fixed', 'sticky'].includes(window.getComputedStyle($plpFilters[0]).position) ? true : false;
    stickyHeight = hasStickyFilter ? (topBannerHeight + plpFilterHeight) : topBannerHeight;
    $body.css('padding-top', isSticky ? stickyHeight : '');
};

const resetSticky = () => {
    $html.removeClass(stickyClass);
    $body.css('padding-top', '');
    topBannerHeight = $topBanner.outerHeight();
    headerOffsetTop = $topBanner.offset().top || 0;
    plpFilterHeight = $plpFilters.length ? $plpFilters.outerHeight() + 10 : 0;
    if ($plpFilters.length) {
        $plpFilters.css('top', topBannerHeight + 'px');
    }

    doSticky();
};

module.exports = {
    init() {
        doSticky();
        $(window)
        .on('scroll', doSticky)
        .on('resize', _.throttle(resetSticky, 100));
    }
};
